import React from 'react';
import './ContactForm.scss';
import icon from '../../assets/banner/icons/Calling.png';
import ServicesData from '../../sections/Services/ServiceData';

const ContactForm = () => {
    return (
        <div className="contact-form-container">
            <form>
                <div className="row">
                    <div className="col-lg-6">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="email" class="form-control" placeholder="Enter your name..." />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div class="form-group">
                            <label>E-mail Address</label>
                            <input type="email" class="form-control" placeholder="Enter email address..." />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="form-group">
                            <label>Service</label>
                            <select class="form-control">
                                <option>Select a service</option>
                                {
                                    ServicesData.map((service, index) => <option key={index} value={service.title}>{service.title}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div class="form-group">
                            <label for="exampleFormControlTextarea1">Messages</label>
                            <textarea class="form-control" placeholder='Enter your messages...' rows="3"></textarea>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <button type="submit" class="btn appointment-btn">Send Message</button>
                    </div>
                    <div className="col-lg-6">
                        <div className="appointment-call">
                            <div className='icon'>
                                <img src={icon} alt="icon" />
                            </div>
                            <div className='call-text'>
                                <h6>0649144852</h6>
                                <h6>0217039149</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            {/* Social Media Links */}
            <div className="social-media-section" data-aos="fade-up" data-aos-duration="1000">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="social-media-container">
                            <h4>Connect with us on social media</h4>
                            <div className="social-links">
                                <a 
                                    href="https://wa.me/27649144852" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="social-link whatsapp-link"
                                    title="WhatsApp"
                                >
                                    <i className="fab fa-whatsapp"></i>
                                </a>
                                <a 
                                    href="https://www.instagram.com/drdollie_dentist?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="social-link instagram-link"
                                    title="Instagram"
                                >
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;